import { isRef } from './isRef';
/**
 * get element from React ref or callback
 */
export var getRefElement = function (ref) {
    if (typeof ref === 'function') {
        return ref();
    }
    if (isRef(ref)) {
        return ref.current;
    }
    return ref;
};
